import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-academies-header',
  templateUrl: './academies-header.component.html',
  styleUrls: ['./academies-header.component.scss']
})
export class AcademiesHeaderComponent implements OnInit {


  Clicked: boolean

  constructor(private router: Router) { }



  ngOnInit(): void {
  }

  openInfo() {
    this.router.navigate(['academies-profile']);
  }
  openHighlight() {
    this.router.navigate(['academies-profile/highlights']);
  }
  openTopPlayers() {
    this.router.navigate(['academies-profile/top-players']);

  }
  OpenCourts() {
    this.router.navigate(['academies-profile/courts']);
  }
  OpenBranches() {
    this.router.navigate(['academies-profile/branches']);
  }
  OpenCoaches() {
    this.router.navigate(['academies-profile/coaches']);
  }
  OpenOutTournaments() {
    this.router.navigate(['academies-profile/coaches']);

  }
  onClickOurTournaments() {
    this.router.navigate(['academies-profile/our-tournaments']);
  }
}
